import { render } from "./KpiSaveConfirmation.vue?vue&type=template&id=13027f50&scoped=true"
import script from "./KpiSaveConfirmation.vue?vue&type=script&lang=js"
export * from "./KpiSaveConfirmation.vue?vue&type=script&lang=js"

import "./KpiSaveConfirmation.vue?vue&type=style&index=0&id=13027f50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13027f50"]])

export default __exports__